import { useMemo } from 'react';
import { usePermissions } from '../helpers/acl/permissions';
import { usePlatformMode } from '../hooks/usePlatformMode';
import { filterGuides } from './filterGuides';
import { GUIDES } from './registry';
import type { GuideMeta } from './types';

/** Registry filtered by the signed-in user's permissions and the platform mode. */
export function useGuides(): { guides: GuideMeta[]; ready: boolean } {
  const { perms, can, ready } = usePermissions();
  const { mode } = usePlatformMode();
  const permsKey = Array.from(perms).sort().join(',');
  const guides = useMemo(
    () => filterGuides(GUIDES, { can, mode }),
    // `can` closes over `perms`; permsKey is the stable dependency.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [permsKey, mode]
  );
  return { guides, ready };
}
